export default __webpack_public_path__ + "static/media/zenjushin-logo.9fd7ad92.png";